<template>
  <div class="box" @scroll="handleScroll($event)">
    <Header ref="headerNav"/>
    <div class="content">
      <div class="headerbg">
        <span>就业实训平台</span>
        <b>EMPLOYMENT TRAINING PLATFOEM</b>

      </div>
      <div class="mainbody">
        <div class="setionbox">
        <p>《就业实训系统》软件从就业实际需求出发，共设计了三大模块：职业生涯规划、求职之路和职场人生。
本系统采用第一人称视角，让学员在系统中进行相关就业知识的学习和就业技能的提升，
学员可以通过完成就业实训不同模块的任务，对自身有更精准的定位从而增强其求职能力。</p>
<div style="height:1px;"></div>
      </div>
      <div class="setionbox">
        <div class="setion">
          <div class="left">
            <p>职业生涯规划</p>
            <div class="line"></div>
            <div class="text">从毕业出路、专业探索、自我探索、自我定向、生涯规划5个方向进行实训，使学员对职业生涯选择、规划有比较切身的体会，便于对自己职业更好的定位，选择自己的就业方向。</div>
          </div>
          <div class="right"><img  style="width:580px; "src="https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/sususus-shetu-sss.png" alt=""></div>
        </div>
      </div>

        <div class="setionbox">
        <div class="setion">

          <div class="right"><img  style="width:633px; "src="https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/susus-jiantousss.png" alt=""></div>
          <div class="left">
            <p>求职之路</p>
            <div class="line"></div>
            <div class="text">通过确定目标、制作材料、展开行动、面试模拟、签订协议，一比一还原真实的从制作简历到入职的求职过程，沉浸式体验真实求职过程，增加面试求职成功率。</div>
          </div>
        </div>
      </div>

       <div class="setionbox">
        <div class="setion">
          <div class="left">
            <p>职场人生</p>
            <div class="line"></div>
            <div class="text">主要分为职场人生引导、生活活动、工作任务、随机事件4部分，充分模拟真实职场生活，体验职场的争分夺秒和紧张的快节奏生活，实现校园与职场生活的无缝对接，使学员更好适应职场生活，早日成为职场“老手”。</div>
          </div>
          <div class="right"><img  style="width:312px;margin-left:100px "src="https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/EmploymentTraining/img3.png" alt=""></div>
        </div>
      </div>

      </div>
    </div>
    <Footer/>

  </div>
</template>

<script>
export default {
  name: 'EmploymentTraining',
  methods:{
     handleScroll (e) {
      if(e.srcElement.scrollTop>2){
        this.$refs.headerNav.showHeadBj()
      }else {
        this.$refs.headerNav.hideHeadBj()
      }
      //滚动事件
    },
  }
}
</script>

<style lang="scss" scoped>
.setionbox:nth-child(odd) {
  background: #f8f8f8;
  .left {
    padding-left: 70px;
  }
}
.left {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: start;
  p {
    font-size: 36px;
    font-family: PingFang SC;
    font-weight: 600;
    color: #333333;
  }
  .line {
    margin-top: 20px;
    width: 120px;
    height: 4px;
    background: #f39a21;
  }
  .text {
    width: 468px;
    margin-top: 60px;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #666666;
    line-height: 1.8;
  }
}
.right {
  flex: 1;
}
.box {
  width: 100%;
  height: 100%;
  overflow: auto;
  // position: relative;
}
.headerbg {
  width: 100%;
  height: 580px;
  background-image: url("~https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/EmploymentTraining/headerbg.png");
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  span {
    font-size: 42px;
    font-family: PingFang SC;
    font-weight: 600;
    color: #ffffff;
  }
  b {
    font-size: 32px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #006cda;
  }
}
.setionbox {
  width: 100%;
  // background-color: red;
  .setion {
    margin: 0 auto;
    width: 1200px;
    padding-top: 80px;
    padding-bottom: 80px;
    // background-color: #f5ff;
    display: flex;
  }
}
.mainbody>.setionbox > p {
  line-height: 1.8;
  padding-top: 30px;
  text-align: center;
  margin-bottom: 60px !important;
  // margin-bottom: 30px !important;
  width: 879px;
  margin: 0 auto;
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #666666;
  background: #f8f8f8;
    // display: inline-block;
  overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
}
</style>



// WEBPACK FOOTER //
// src/pages/EmploymentTraining.vue